/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'

// Store functionality
import actions from './actions'
import getters from './getters'
import modules from './modules'
import mutations from './mutations'
import state from './state'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

// Create a new store
const store = new Vuex.Store({
  actions,
  getters,
  modules,
  mutations,
  state,
  plugins: [
    createPersistedState({
      /* Check All Options You Can Pass At this Link */
      /* https://github.com/robinvdvleuten/vuex-persistedstate#createpersistedstateoptions */
      key: 'galaxy-ps',
      // Declare All The State We Want to Persist (use dot anotation for object.key)
      paths: [
        'initialLoad',
        'app',
        'currentUser',
        'viewCustomFields',
        // 'admin/accountInventory.masterAccounts',
        // 'admin/accountInventory.masterPayers',
        // 'admin/accountInventory.pods',
        // 'admin/oppregAdmin.masterWorkloads',
        // 'admin.customers',
        // 'admin.mPayers',
        // 'user/requestAws'
        // 'admin/financialAdministration.allAccounts'
      ]
    })
  ]
})

export default store
